import styled from 'styled-components';

export const StyledDiv = styled.div`
  width: 100%;
`;
